// extracted by mini-css-extract-plugin
module.exports = {"panel":"language-panel_panel__2MTxM","header":"language-panel_header__wSfjY","body":"language-panel_body__1a9kK","current":"language-panel_current__2p6H2"};